import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { variant } from 'styled-system';
import Row from '../Container/Row';
import { CaptionText } from '../Text/Heading';
import { Variant } from '../../utils/constants';
import Icon from '../Icon';

const commonStyled = {
  border: '1px solid',
  borderRadius: 4,
  width: 'fit-content',
};

const BannerMessageContainer = styled(Row)(
  variant({
    variants: {
      [Variant.Info]: {
        ...commonStyled,
        backgroundColor: 'tertiaryBlueLighter',
        borderColor: 'tertiaryBlue',
      },
      [Variant.Error]: {
        ...commonStyled,
        backgroundColor: 'tertiaryOrangeLighter',
        borderColor: 'tertiaryOrangeDarker',
      },
      [Variant.Hint]: {
        ...commonStyled,
        backgroundColor: 'greyLighter',
        borderColor: 'grey',
      },
    },
  })
);

const TextMessage = styled(CaptionText)(
  variant({
    variants: {
      [Variant.Info]: {
        color: 'tertiaryBlue',
      },
      [Variant.Error]: {
        color: 'tertiaryOrange',
      },
      [Variant.Hint]: {
        lineHeight: '18px',
        color: 'greyDarker',
      },
    },
  })
);

const MdErrorIcons = styled(Icon)(
  variant({
    variants: {
      [Variant.Error]: {
        color: 'tertiaryOrange',
      },
    },
  })
);

TextMessage.defaultProps = {
  numberOfLines: 0,
  ellipsizeMode: 'tail',
};

const BannerMessage = ({
  variant = Variant.Info,
  numberOfLines,
  children,
  ...restProps
}) => {
  return (
    <Row background="transparent" {...restProps} flex={'none'}>
      <BannerMessageContainer
        variant={variant}
        padding={2}
        paddingLeft={3}
        paddingRight={3}
      >
        {variant === Variant.Error && (
          <MdErrorIcons
            icon="ErrorOutlineIcon"
            fontsize="titleSmall"
            variant={variant}
          />
        )}
        <TextMessage
          marginX={2}
          marginY={2}
          variant={variant}
          numberOfLines={numberOfLines}
        >
          {children}
        </TextMessage>
      </BannerMessageContainer>
    </Row>
  );
};

BannerMessage.propTypes = {
  children: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  variant: PropTypes.string,
  restProps: PropTypes.object,
  numberOfLines: PropTypes.number,
};

export default BannerMessage;
